import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

/** 4xx hatalarında tekrar denenmez (yetki, doğrulama); ağ ve 5xx en fazla 2 kez. */
export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        refetchOnWindowFocus: false,
        retry: (count, error) => {
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
          return count < 2;
        },
      },
      mutations: { retry: false },
    },
  });
}
